module.exports = __webpack_public_path__ + "img/plus.511f5b80.svg";